<template>
  <div>
    <el-upload
      action="/api/v1/archives"
      name="archive"
      ref="upload"
      :headers="headers"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      multiple
    >
      <el-button size="small">上传文件</el-button>
    </el-upload>
  </div>
</template>

<script>
import { OopsErrorELMessage } from "@/mixins";
export default {
  name: "ArchiveUpload",
  mixins: [OopsErrorELMessage],
  computed: {
    headers() {
      return {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`
      };
    }
  },
  methods: {
    handleSuccess(response, file, fileList) { /*eslint-disable-line*/
      this.$emit("add", response);
    },
    handleRemove(file, fileList) {/*eslint-disable-line*/
      this.$emit("delete", file.response);
    },
    beforeRemove(file, fileList) { /*eslint-disable-line*/
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleError(err) {
      this.oopsError(err);
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.is-success {
  display: none;
}
</style>
